import { render, staticRenderFns } from "./SafetyInstructionChat.vue.html?vue&type=template&id=fa12c552&scoped=true&external"
import script from "./SafetyInstructionChat.vue.js?vue&type=script&lang=js&external"
export * from "./SafetyInstructionChat.vue.js?vue&type=script&lang=js&external"
import style0 from "./SafetyInstructionChat.vue.scss?vue&type=style&index=0&id=fa12c552&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa12c552",
  null
  
)

export default component.exports